module.exports = __webpack_public_path__ + "static/img/che03.d5cf991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che03.png
// module id = 8M5C
// module chunks = 1